import { render, staticRenderFns } from "./lista_fromulario.vue?vue&type=template&id=cf9e281a&scoped=true"
import script from "./lista_fromulario.vue?vue&type=script&lang=js"
export * from "./lista_fromulario.vue?vue&type=script&lang=js"
import style0 from "./lista_fromulario.vue?vue&type=style&index=0&id=cf9e281a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9e281a",
  null
  
)

export default component.exports